export const jsClasses = {
    active: 'js-is-active',
    open: 'js-is-active',
    notActive: 'js-is-not-active',
};

export const mqSizes = {
    sm: 768,
    md: 1024,
};

export default {
    jsClasses,
    mqSizes,
};
